import { Injectable } from '@angular/core';
import {HttpClient, HttpErrorResponse} from "@angular/common/http";
import {environment} from "../../environments/environment";
import {Observable, throwError} from "rxjs";
import {catchError, map} from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class TestimonialService {

  constructor(private http: HttpClient) { }

  private baseUrl: string = environment.apiUrl;

  private static handleError(error: HttpErrorResponse) {
    console.log(error);
    return throwError('Error! something went wrong.');
  }

  addTestimonial(Payload) {
    return this.http.post<any>(`${this.baseUrl}/testimonial/add-testimonial`, Payload)
      .pipe(map(res => {
        return res;
      }));

  }

  editTestimonial(Payload) {
    return this.http.post<any>(`${this.baseUrl}/testimonial/edit-testimonial`, Payload)
      .pipe(map(res => {
        return res;
      }));

  }

  getTestimonialById(Payload) {
    return this.http.post<any>(`${this.baseUrl}/testimonial/get-testimonial-by-id`, Payload)
      .pipe(map(res => {
        return res;
      }));

  }

  deleteTestimonial(Payload) {
    return this.http.post<any>(`${this.baseUrl}/testimonial/delete-testimonial`, Payload)
      .pipe(map(res => {
        return res;
      }));

  }

  getAllTestimonial(): Observable<any> {
    return this.http.get(`${this.baseUrl}/testimonial/get-all-testimonial`).pipe(
      map((res) => {
        return res;
      }),
      catchError(TestimonialService.handleError));
  }
}
